import { env } from '@/constants';
import { useAuthenticationStore } from '@/stores/AuthenticationStore/AuthenticationStore';
import { SharedRoutes } from '@/shared-routes';
import { urlWithRedirect } from '@/utils/urlUtils';
import { AmplitudeFeatureFlagService } from '@/services/feature/providers/AmplitudeFeatureFlagService';
import type { AuthToken, HttpServiceConfiguration } from '@art-basel/artbasel-lib-platform';

export class PlatformHttpServiceConfiguration implements HttpServiceConfiguration {
  public authTokenKey(): string {
    return env.VITE_AUTH_TOKEN_KEY;
  }

  public corsProxy(): string {
    return env.VITE_CORS_PROXY;
  }

  public restEndpoint(): string {
    return env.VITE_PLATFORM_REST_ENDPOINT;
  }

  public apiKey(): string {
    return env.VITE_X_API_KEY;
  }

  public redirectToLogin(): void {
    if (
      global.location.pathname &&
      global.location.pathname.indexOf(SharedRoutes.LOGIN) === -1 &&
      global.location.pathname.indexOf(SharedRoutes.LOGOUT) === -1
    ) {
      return global.location.replace(urlWithRedirect(SharedRoutes.LOGIN, global.location.pathname));
    } else {
      return global.location.replace(urlWithRedirect(SharedRoutes.LOGIN, null));
    }
  }

  public updateAuthToken(token: AuthToken | null): void {
    useAuthenticationStore().setAuthToken(token);
  }

  public featureFlagProvider() {
    const provider = new AmplitudeFeatureFlagService();
    provider.initialize();
    return provider;
  }
}

export const platformHttpServiceConfiguration = new PlatformHttpServiceConfiguration();
